import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function AdminForceChangePassword() {
    const { user, changePassword, logout } = useAuth();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!user) {
            navigate('/login', { replace: true });
            return;
        }
        if (user.userType !== 'admin') {
            navigate('/', { replace: true });
            return;
        }
        if (!user.must_change_password) {
            navigate('/admin', { replace: true });
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Die Passwoerter stimmen nicht ueberein');
            return;
        }
        if (password.length < 8) {
            setError('Das Passwort muss mindestens 8 Zeichen haben');
            return;
        }

        setLoading(true);
        try {
            await changePassword(null, password);
            navigate('/admin', { replace: true });
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    };

    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <div className="card mt-5">
                    <div className="card-body">
                        <h4 className="card-title mb-3">Neues Passwort vergeben</h4>
                        <p className="text-muted mb-4">
                            Bevor du fortfahren kannst, lege bitte ein neues Passwort fest.
                        </p>

                        {error && <div className="alert alert-danger">{error}</div>}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Neues Passwort</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoFocus
                                    minLength={8}
                                    placeholder="Mindestens 8 Zeichen"
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Passwort bestaetigen</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    minLength={8}
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Speichern...
                                    </>
                                ) : (
                                    'Passwort speichern'
                                )}
                            </button>
                        </form>

                        <div className="text-center mt-3">
                            <button
                                type="button"
                                className="btn btn-link text-muted small"
                                onClick={() => { logout(); navigate('/login', { replace: true }); }}
                            >
                                Abmelden
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminForceChangePassword;
